export const DOC_FLOW_SENDING_COMMUNICATION_SETTINGS_NOTIFICATION_ID_PERMANENT =
  'docFlowSendingCommunicationSettingsPermanentNotification'

export const DOC_FLOW_SENDING_COMMUNICATION_SETTINGS_NOTIFICATION_ID_ERROR =
  'docFlowSendingCommunicationSettingsErrorNotification'

export const DOC_FLOW_SENDING_COMMUNICATION_SETTINGS_NOTIFICATION_ID_SUCCESS =
  'docFlowSendingCommunicationSettingsSuccessNotification'
